import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "max-w-screen-xl px-24" };
const _hoisted_2 = { class: "text-2xl font-medium mb-6" };
const _hoisted_3 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("section", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.account.name) + " Terms and Conditions", 1),
            _createElementVNode("div", {
                innerHTML: _ctx.account.terms,
                class: ""
            }, null, 8, _hoisted_3)
        ])
    ]));
}
